/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreatePlatformGcpIamCredentialForm,
  CreatePlatformGcpIamCredentialForm$Outbound,
  CreatePlatformGcpIamCredentialForm$outboundSchema,
} from "../components/createplatformgcpiamcredentialform.js";

export type CreateGcpIamPlatformCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateGcpIamPlatformCredentialRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createPlatformGcpIamCredentialForm: CreatePlatformGcpIamCredentialForm;
};

/** @internal */
export type CreateGcpIamPlatformCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateGcpIamPlatformCredentialSecurity$outboundSchema:
  z.ZodMiniType<
    CreateGcpIamPlatformCredentialSecurity$Outbound,
    CreateGcpIamPlatformCredentialSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createGcpIamPlatformCredentialSecurityToJSON(
  createGcpIamPlatformCredentialSecurity:
    CreateGcpIamPlatformCredentialSecurity,
): string {
  return JSON.stringify(
    CreateGcpIamPlatformCredentialSecurity$outboundSchema.parse(
      createGcpIamPlatformCredentialSecurity,
    ),
  );
}

/** @internal */
export type CreateGcpIamPlatformCredentialRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreatePlatformGcpIamCredentialForm:
    CreatePlatformGcpIamCredentialForm$Outbound;
};

/** @internal */
export const CreateGcpIamPlatformCredentialRequest$outboundSchema:
  z.ZodMiniType<
    CreateGcpIamPlatformCredentialRequest$Outbound,
    CreateGcpIamPlatformCredentialRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      createPlatformGcpIamCredentialForm:
        CreatePlatformGcpIamCredentialForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        createPlatformGcpIamCredentialForm:
          "CreatePlatformGcpIamCredentialForm",
      });
    }),
  );

export function createGcpIamPlatformCredentialRequestToJSON(
  createGcpIamPlatformCredentialRequest: CreateGcpIamPlatformCredentialRequest,
): string {
  return JSON.stringify(
    CreateGcpIamPlatformCredentialRequest$outboundSchema.parse(
      createGcpIamPlatformCredentialRequest,
    ),
  );
}
